import axios from "axios";

export const contactService = (body) => {
    return axios.post(
        `https://api.chatpsych.com:8000/send_email?first_name=${body.first_name}&last_name=${body?.last_name}&email=${body?.email}&phone=${body?.phone}&subject=${body?.subject}&message=${body?.message}`)
}
